/** Collections exposed through auto-generated instance CRUD. */
export enum ECollection {
  CATEGORIES = 'categories',
  PRODUCTS = 'products',
  CUSTOMERS = 'customers',

  // ── Expense reference data ──────────────────────────────────────────────────
  // Reference data only, and only what a screen actually reads: expense types and
  // payment modes fill the expense form's dropdowns, persons fill the Accounts
  // ledger's, and suppliers fill the expense form's Person picker. There is no
  // masters-admin screen — each of these is created inline from the form that needs
  // it, which is why there are no units/locations/supplier-type vocabularies here.
  //
  // The financial collections of the module — expenses, expense_logs,
  // supplier_accounts, expense_photos — are deliberately ABSENT: they are NO_ACCESS at
  // the collection level so that a staff user cannot reach them through the generic
  // /schema/.../query route and bypass the backend's owner check. Reach those through
  // EApiPath endpoints instead. See the spec's access-control note.
  EXPENSE_TYPES = 'expense_types',
  EXPENSE_PAYMENT_MODES = 'expense_payment_modes',
  EXPENSE_PERSONS = 'expense_persons',
  SUPPLIERS = 'suppliers',
}
